import { render, staticRenderFns } from "./userinfor.vue?vue&type=template&id=4da696ca&scoped=true"
import script from "./userinfor.vue?vue&type=script&lang=ts"
export * from "./userinfor.vue?vue&type=script&lang=ts"
import style0 from "./userinfor.vue?vue&type=style&index=0&id=4da696ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da696ca",
  null
  
)

export default component.exports